import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/page';
import { FilterValuesProps, useFilter, ValueSetterFiltersProps } from 'hooks/useFilter';

export function SecaoListColunasDinamicasFilter(): JSX.Element {
    const { handleFilterReset, handleFilterSubmit, setDefaultFilters } = useFilter();

    const [filterCod, setFilterCod] = useState<FilterValuesProps>({
        property: 'idConfiguracaoPropriedade',
        operator: 'eq',
        value: null,
    });

    const [filterTag, setFilterTag] = useState<FilterValuesProps>({
        property: 'dsConfiguracao',
        operator: 'like',
        value: '',
    });
    const filters: ValueSetterFiltersProps[] = [
        { value: filterCod, setter: setFilterCod },
        { value: filterTag, setter: setFilterTag },
    ];

    useEffect(() => {
        setDefaultFilters({ filters });
    }, []);

    return (
        <Filter reset={() => handleFilterReset({ filters })} submit={() => handleFilterSubmit({ filters })}>
            <Grid item flex={1}>
                <CissTextField
                    label="Código"
                    value={filterCod.value}
                    onChange={(e) => setFilterCod((oldState) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>

            <Grid item flex={2}>
                <CissTextField
                    label="Nome do campo"
                    value={filterTag.value}
                    onChange={(e) => setFilterTag((oldState) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
